/**
 * Titolo di ripiego per una task commerciale salvata senza titolo.
 *
 * Se l'utente scrive solo nella descrizione, il titolo diventa la prima riga
 * non vuota della descrizione (senza HTML, troncata a ~120 caratteri).
 * Usato dal composer inline della cronologia e dal drawer attività/nota.
 */
export const ACTIVITY_TITLE_MAX_LENGTH = 120;

const ENTITIES: Record<string, string> = {
  '&nbsp;': ' ',
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#39;': "'",
  '&apos;': "'",
};

/** Testo semplice da HTML (o testo già semplice), con un a capo per ogni blocco. */
function htmlToLines(input: string): string[] {
  const text = input
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|blockquote|pre|tr)>/gi, '\n')
    .replace(/<[^>]*>/g, '')
    .replace(/&(nbsp|amp|lt|gt|quot|apos|#39);/g, (m) => ENTITIES[m] ?? m);
  return text.split(/\r?\n/);
}

/** Prima riga utile della descrizione come titolo; stringa vuota se non c'è testo. */
export function activityTitleFromDescription(
  description: string | null | undefined,
  maxLength: number = ACTIVITY_TITLE_MAX_LENGTH,
): string {
  if (!description) return '';
  const firstLine = htmlToLines(description)
    .map((line) => line.replace(/\s+/g, ' ').trim())
    .find((line) => line.length > 0);
  if (!firstLine) return '';
  if (firstLine.length <= maxLength) return firstLine;
  return `${firstLine.slice(0, maxLength - 1).trimEnd()}…`;
}

/** Titolo effettivo: quello digitato, altrimenti la prima riga della descrizione. */
export function resolveActivityTitle(title: string | null | undefined, description: string | null | undefined): string {
  const typed = (title ?? '').trim();
  return typed || activityTitleFromDescription(description);
}
